'use strict'

import $ from 'jquery'

export default class Accordion{
  constructor(el) {
    this.$el = $(el)

    this.accordionTitles = $(this.$el).find('.accordion-title')

    $(document).ready(()=>{
      this.accordionTitles.on('click touch', (e)=>{
        $(e.currentTarget).parents('.accordion-item').toggleClass('open')
      })
    })
  }
}
